<template>
  <!-- 导航开始 -->
  <div class='commonHomeNoticemodify' :class="{appBool:appBool}">
    <div class="scrollBox">
      <div class="traceStoreBox">
        <h2 class="mb-0">
          {{info.title}}
        </h2>
        <p class="content">
          {{info.timesStr}}
        </p>
        <hr>
        <div class="mb-3">
          <div class="box">
            {{info.contents}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import resultCommons from '@/util/resultcommons';

export default {
  name: 'commonHomeNoticemodify',
  props: {
    token: {
      type: String,
      default: '',
    },
    appBool: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 提交中
      isLoading: false,
      // 跟进类型
      info: {},
    };
  },
  computed: {
  },
  methods: {
  },
  components: {
  },
  created() {
    resultCommons.apiUsernoticeinfo(this, { token: this.token }).then((ob) => {
      if (ob.state === 200) {
        this.info = ob.data;
      } else {
        this.$message.showMsgBox({ type: 'warning', content: ob.message });
      }
    });
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonHomeNoticemodify{
  box-shadow: 0 0 1rem rgba(0, 0, 0, .5);
  background: #1C1B22;
  width: 480px;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  border-radius: 1rem;
  overflow: hidden;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  justify-content: center;
  &.appBool{
    height: 100%;
    margin: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  div.scrollBox{
    padding: 30px 50px;
    overflow-y: auto;
    h2{
      padding-bottom: 30px;
      font-family: 'gilroy-semibold';
    }
    .towBox{
      display: flex;
      div.box{
        flex: 1;
        &:first-child{
          margin-right: 15px;
        }
      }
    }
    .anniuBox{
      span{
        height: 35px;
        i.iconfont{
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/home/noticeinfo.vue